/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteUserSessionRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/session_messages.pb'
import {DeleteUserSessionResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/session_messages.pb'


export const genericDeleteUserSession = (request: DeleteUserSessionRequest, options?: CashRequestOptions) => post<DeleteUserSessionRequest, DeleteUserSessionResponse>("/2.0/cash/generic-delete-user-session", request, {...options, rejectOnError: true })